/**
 * Backend permission names.
 *
 * These mirror `Modules\\Permission\\Enums\\Permission` on the API; the string
 * values must stay identical or a gate silently closes.
 */
export const AppPermission = {
  VIEW_ESTIMATION_SETTINGS: 'estimation:view_estimation_settings',
  MANAGE_ESTIMATION_SETTINGS: 'estimation:manage_estimation_settings',
  VIEW_JOB_TITLE_SALARY: 'jobtitle:view_job_title_salary',
  MANAGE_JOB_TITLE_SALARIES: 'jobtitle:manage_job_title_salaries',
} as const;

export type AppPermissionType =
  (typeof AppPermission)[keyof typeof AppPermission];
